// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uXyv","label":"styles_label__3t-j_"};